/**
 * Created by adnanchohdry on 25/12/16.
 */
"use strict";

class CustomerFolioController {

    constructor($parse, $window, $timeout, Upload, SSHttpService, SSUtilService, SSConfigService, SSUserService, SSAppService, SSEoiService, SSAwsService, SSAlertService, SSConfirmationService) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;
        self.$window = $window;

        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.SSAppService = SSAppService;
        self.SSEoiService = SSEoiService;
        self.SSAwsService = SSAwsService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.croppedDataUrl = false;
        self.errorMsg = '';
        self.countries = self.SSConfigService.getCountries();
        self.updateProfilePicContainer = false;
        self.result = '';
        self.policyDocData = '';
        self.signature = null;
        self.policy = null;
        self.fileExt = null;
        self.blob = '';
        self.updateCountry = 702; // Singapore
        self.updateMaritalStatus = self.SSConfigService.getMaritalStatuses()[0].id;
        self.updateGender = self.SSConfigService.getGenders()[0].id;
        self.nationality = 702;//singaporean

        self.maritalStatuses = self.SSConfigService.getMaritalStatuses();
        self.genders = self.SSConfigService.getGenders();
        self.nationalities = self.SSConfigService.getNationalities();
        self.icOrPassport = null;
        self.buyerDocumnets = {};
        self.TYPE_ENABLE_2FA = 1;

        self.croppedDataUrl = '';
        self.progress = '';

        self.SMS_SERVICE_TOKEN_SENT_SUCCESSFULLY = SHOWSUITE.SMS_SERVICE_TOKEN_SENT_SUCCESSFULLY; // 1
        self.SMS_SERVICE_TOKEN_WAS_ALREADY_SENT = SHOWSUITE.SMS_SERVICE_TOKEN_WAS_ALREADY_SENT; // 2
        self.SMS_SERVICE_TOKEN_SENT_ERROR = SHOWSUITE.SMS_SERVICE_TOKEN_SENT_ERROR;  // 3
        self.SMS_SERVICE_TOKEN_MISSING_REQUIRED_PARAMS = SHOWSUITE.SMS_SERVICE_TOKEN_MISSING_REQUIRED_PARAMS;  // 4
        
        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;
        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;

        // Constant percentage values for progress bar
        self.EMAIL_VERIFICATION = 10;
        self.MOBILE_VERIFICATION = 10;
        self.FULL_NAME = 4;
        self.INDUSTRY = 5;
        self.OCCUPATION = 5;
        self.GENDER = 5;
        self.IDENTITY_TYPE = 7;
        self.NATIONALITY = 5;
        self.NRIC_OR_PASSPORT = 6;
        self.MARITAL_STATUS = 5;
        self.DOB = 5;
        self.MOBILE_NUMBER = 5;
        self.ADDRESS = 10;
        self.MAILING_ADDRESS = 3;
        self.PERSONAL_DOCUMENTS = 15;

        // Initialize with 10 points of account creation
        self.progressbarValue = self.EMAIL_VERIFICATION;

        self.init();
    }

    init() {
        const self = this;

        //self.maskPhoneNumber(self, 'ctrl.', 'formPersonalDetails');

        self.updateProgress();

        loading(true);
        // Get user profile
        if (self.SSUserService.getUser()) {
            self.getProfile();
        } else {
            self.SSUserService.showLoginModal();
        }

        self.setIndividualTitle();

        // Get buyer profile
        self.getBuyerProfile();
        self.maskPhoneNumber(self, 'ctrl.', 'formPersonalDetails');

        self.updateSelector();
        loading(false);

        jQuery('.datepicker').datepicker({dateFormat: 'yy-mm-dd'});

    }

    setIndividualTitle(){
        const self = this;

        self.individual_titles = [
            {
                id: 1,
                name: 'MR'
            },
            {
                id: 2,
                name: 'MRS'
            },
            {
                id: 3,
                name: 'MISS'
            },
            {
                id: 4,
                name: 'DR'
            }
        ];

        self.$timeout(function() { 
            $("select.eoi-select#salutation").niceSelect('update');
        });
    }

    updateProgress(){
        const self = this;

        angular.element("#progress").css('width', self.progressbarValue + '%');
    }

    updateProgressBarValue(){
        const self = this;

        let progressValue = self.EMAIL_VERIFICATION;

        if(self.updateFirstName && self.updateLastName){
            progressValue += self.FULL_NAME;
        }
        if(self.individual_industry){
            progressValue += self.INDUSTRY;
        }
        if(self.individual_occupation){
            progressValue += self.OCCUPATION;
        }
        if(self.individual_gender){
            progressValue += self.GENDER;
        }
        if(self.individual_identity_type){
            progressValue += self.IDENTITY_TYPE;
        }
        if(self.individual_nationality){
            progressValue += self.NATIONALITY;
        }
        if(self.individual_national_id || self.individual_passport_no){
            progressValue += self.NRIC_OR_PASSPORT;
        }
        if(self.individual_marital_status){
            progressValue += self.MARITAL_STATUS;
        }
        if(self.individual_dob){
            progressValue += self.DOB;
        }
        if(self.phone1_contact_value){
            progressValue += self.MOBILE_NUMBER;
        }

        // Mobile verification
        if(self.buyer){
            if(self.buyer.phone1_contact && self.buyer.phone1_contact.verified){
                progressValue += self.MOBILE_VERIFICATION;
            }
        }

        // Primary address
        if(self.primary_address_line1 && self.primary_address_country && self.primary_address_postcode){
            progressValue += self.ADDRESS;
        }

        // Mailing address
        if(self.mailing_address_same || (self.mailing_address_line1 && self.mailing_address_country 
            && self.mailing_address_postcode)){

            progressValue += self.MAILING_ADDRESS;
        }

        // Personal documents
        if(self.buyer && self.buyer.documents){
            if(self.buyer["documents"]['Passport']){
                progressValue += self.PERSONAL_DOCUMENTS;
            }
            else if(self.buyer["documents"]['NRIC_Front'] && self.buyer["documents"]['NRIC_Back']){
                progressValue += self.PERSONAL_DOCUMENTS;
            }
        }

        self.progressbarValue = progressValue;

        self.updateProgress();
    }

    /**
     * Get profile.
     */
    getProfile() {
        const self = this;

        self.user = null;

        self.SSHttpService.getAPIRequest('sec/me').then(
            function (responseObj) {

                if (responseObj instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(responseObj);
                    return;
                }

                self.SSUtilService.log('User Object');
                self.SSUtilService.log(responseObj);
                self.updateLocalUser(responseObj.data.user);
                self.SSAppService.isPageLoaded = true;
            });
    }

    updateOccupationSelector() {
        const self = this;
        self.$timeout(function() { 
            $("select.eoi-select#occupation").niceSelect('update');
            $("select.eoi-select#occupation_individual").niceSelect('update');
        });
        self.updateProgressBarValue();
    }

    /**
     * Get buyer profile.
     */
    getBuyerProfile() {
        const self = this;

        self.buyer = null;
        let param = {
            include:'individual, company, primary_address, mailing_address, email_contact, phone1_contact, phone2_contact, documents'
        }
        self.SSHttpService.getAPIRequest('sec/buyers', param).then(
            function (responseObj) {
                
                if (responseObj instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(responseObj);
                    return;
                }

                self.buyer = responseObj.data.buyers[0];
                self.SSUtilService.log('current buyer');
                self.SSUtilService.log(self.buyer);

                if(self.buyer){
                    self.updateLocalBuyer(self.buyer);
                }
                else{
                    self.updateSelector();
                    self.updateProgressBarValue();
                }

                //self.SSAppService.isPageLoaded = true;
            });
    }

    updateLocalUser(user) {
        const self = this;
        
        self.user = user;

        let maritalStatusItem = self.SSUtilService.findValueFromArray(self.maritalStatuses, 'id', user.marital_status);
        let genderItem = self.SSUtilService.findValueFromArray(self.genders, 'id', user.gender);
        let nationalityItem = self.SSUtilService.findValueFromArray(self.nationalities, 'id', user.nationality);
        self.user.countryName = self.SSAppService.getCountryName(user.country);
        self.user.maritalStatusName = maritalStatusItem != null ? maritalStatusItem.name : '';
        self.user.genderName = genderItem != null ? genderItem.name : '';
        self.user.nationalityName = nationalityItem != null ? nationalityItem.name : '';
        self.icOrPassport  = (user.nationality==702)?'ic':'passport';
        self.email_contact_value = self.user.email;
        self.phone1 = self.user.phone1;
    }

    updateLocalBuyer(buyer) {
        const self = this;

        self.buyer = buyer;

        if(self.buyer){

            if(self.buyer.documents){
                _.each(self.buyer.documents, function(document){

                    if (!self.buyer.hasOwnProperty("documents")) {
                        self.buyer["documents"] = {};
                    }
                    self.buyer["documents"][document.name] = document;

                    //To retrieve preview image
                    let url = 'sec/assets/presigned-url';
                    let params = {
                        'model': self.ASSET_MODEL_BUYER_DOCUMENT,
                        'id': document.id
                    };
                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        loading(false);
                        if (response instanceof Error) {
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }
                        self.buyer["documents"][document.name]["show_file_url"] = response.data.presigned_url;
                    });

                 });
            }

            if(self.buyer.individual){
                self.individual_title = self.buyer.individual.title != null ? parseInt(self.buyer.individual.title) : '';
                self.updateFirstName = self.buyer.individual.first_name;
                self.updateLastName = self.buyer.individual.last_name;
                self.individual_industry = self.buyer.individual.industry;
                self.individual_gender = self.buyer.individual.gender;
                self.individual_nationality = self.buyer.individual.nationality;
                self.individual_dob = self.buyer.individual.dob;
                self.individual_occupation = self.buyer.individual.occupation != null ? self.buyer.individual.occupation : '';
                self.individual_identity_type = self.buyer.individual.identity_type;
                self.individual_nationality = self.buyer.individual.nationality;
                self.individual_marital_status = self.buyer.individual.marital_status;

                if(self.buyer.individual.identity_type == 'foreigner'){
                    self.individual_passport_no = self.buyer.individual.passport_no;
                }
                else{
                    self.individual_national_id = self.buyer.individual.national_id;
                }

                // Email and phone
                self.email_contact_value = self.buyer.email_contact.value != null ? self.buyer.email_contact.value:self.user.email;
                
                if(self.buyer.phone1_contact){
                    self.phone1_contact_value = self.buyer.phone1_contact.value;
                    self.phone1_contact_value_verified = self.buyer.phone1_contact.verified;
                }
                if(self.buyer.phone2_contact){
                    self.phone2_contact_value = self.buyer.phone2_contact.value;
                    self.phone2_contact_value_verified = self.buyer.phone2_contact.verified;
                }
                
                self.maskPhoneNumber(self, 'ctrl.', 'formPersonalDetails');
            }

            // Primary address
            if(self.buyer.primary_address){
                self.primary_address_line1 = self.buyer.primary_address.line1;
                self.primary_address_line2 = self.buyer.primary_address.line2 != null ? self.buyer.primary_address.line2 : '';
                self.primary_address_country = self.buyer.primary_address.country;
                self.primary_address_city = self.buyer.primary_address.city != null ? self.buyer.primary_address.city : '';
                self.primary_address_unit_no = self.buyer.primary_address.unit_no != null ? self.buyer.primary_address.unit_no : '';
                self.primary_address_district = self.buyer.primary_address.district != null ? self.buyer.primary_address.district : '';
                self.primary_address_postcode = self.buyer.primary_address.postcode;
                
            }

            // Mailing address
            if(self.buyer.mailing_address){
                self.mailing_address_line1 = self.buyer.mailing_address.line1;
                self.mailing_address_line2 = self.buyer.mailing_address.line2 != null ? self.buyer.mailing_address.line2 : '';
                self.mailing_address_country = self.buyer.mailing_address.country;
                self.mailing_address_city = self.buyer.mailing_address.city != null ? self.buyer.mailing_address.city : '';
                self.mailing_address_unit_no = self.buyer.mailing_address.unit_no != null ? self.buyer.mailing_address.unit_no : '';
                self.mailing_address_district = self.buyer.mailing_address.district != null ? self.buyer.mailing_address.district : '';
                self.mailing_address_postcode = self.buyer.mailing_address.postcode;
                
            }

            // self.icOrPassport  = (user.nationality==702)?'ic':'passport';
        }
        self.updateSelector();
        self.updateProgressBarValue();
    }

    updateNationality(){
        const self = this;

        if(self.individual_identity_type != 'foreigner'){
            self.individual_nationality = 702;
        }

        self.updateSelector();
        self.updateProgressBarValue();
    }
    
    updateSelector(){
        const self = this;
        self.$timeout(function() {
            $("select.eoi-select").niceSelect('update');
        });
        if(self.individual_title){
            self.$timeout(function() {
                $("select.eoi-select#salutation").niceSelect('update');
            });
        }
    }
    /**
     * Update password.
     */
    setUpdatePasswordContainer(show) {
        const self = this;

        self.updatePasswordContainer = show;
        if (!show) {
            angular.element('#updatePassword').modal('hide');
        }
    }

    resetPasswordErrors() {
        const self = this;

        self.errCurrentPassword = null;
        self.errPassword = null;
        self.errPasswordConfirmation = null;
    }

    updatePassword() {
        const self = this;

        let param = {
            'user_current_password': self.currentPassword,
            'user_password': self.password,
            'user_password_confirmation': self.passwordConfirmation
        };

        self.resetPasswordErrors();

        self.passwordLoadingIndicator = true;

        self.SSHttpService.putAPIRequest('sec/me/password', param).then(
            function (responseObj) {
                self.passwordLoadingIndicator = false;

                if (responseObj instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(responseObj);

                    let errorData = responseObj.data;

                    if (_.has(errorData, 'user_current_password')) {
                        self.errCurrentPassword = errorData.user_current_password[0];
                    }
                    if (_.has(errorData, 'user_password')) {
                        self.errPassword = errorData.user_password[0];
                    }
                    if (_.has(errorData, 'user_password_confirmation')) {
                        self.errPasswordConfirmation = errorData.user_password_confirmation[0];
                    }
                    return;
                }

                self.SSUtilService.log(responseObj);

                self.setUpdatePasswordContainer(false);

                self.SSAlertService.success('Success!', "Password updated successfully!");
            });
    }

    /**
     * Update 2FA.
     */
    updateTwoFA() {
        const self = this;

        self.twofa_code = '';
        self.errTwoFACode = '';
        if (!self.user.phone1) {
            self.SSAlertService.danger('Error!', 'Please update your contact number.');
            return;
        }

        loading(true);
        self.SSHttpService.postAPIRequest('sec/me/toggle2fa').then(function (responseObj) {
            loading(false);

            if (responseObj instanceof Error) {

                if (responseObj.sub_code == self.SMS_SERVICE_TOKEN_SENT_SUCCESSFULLY) {
                    self.showUpdate2FAModal(responseObj);
                }
                else if (responseObj.sub_code == self.SMS_SERVICE_TOKEN_WAS_ALREADY_SENT) {
                    self.showUpdate2FAModal(responseObj);
                }
                else if (responseObj.sub_code == self.SMS_SERVICE_TOKEN_SENT_ERROR) {
                    self.SSAlertService.danger('Error!', 'Please update your contact number.');
                    self.showUpdate2FAModal(responseObj);
                }
                else{
                    self.SSAlertService.parseAndDisplayError(responseObj);
                }
            }
            else if (self.user.twofa_enabled) {
                self.SSConfirmationService.getConfirmed(
                    'Confirm!',
                    '2FA updated successfully.',
                    self.SSConfirmationService.TYPE_DEFAULT,
                    function() {
                        self.user.twofa_enabled = 0;
                    }
                );
            }
        });
    }

    showUpdate2FAModal(response){
        const self = this;

        self.prefix_2fa = (response.data && response.data.prefix_2fa)? response.data.prefix_2fa:'';
        self.hideModals();
        self.showModal = true;
        $('#updateTwoFAModal').modal('show');
    }

    verifyTwoFA() {
        const self = this;

        self.errTwoFACode = '';

        let params = {
            email: self.user.email,
            twofa_code: self.prefix_2fa+self.twofa_code,
            twofa_type: self.TYPE_ENABLE_2FA
        };

        loading(true);
        self.SSHttpService.postAPIRequest('2fa', params).then(function (responseObj) {
            loading(false);
            if (responseObj instanceof Error) {
                self.SSAlertService.parseAndDisplayError(responseObj);

                self.errTwoFACode = "Invalid Code";
                return;
            }

            self.hideModals();

            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                '2FA updated successfully.',
                self.SSConfirmationService.TYPE_DEFAULT,
                function() {
                    self.user.twofa_enabled = 1;
                }
            );
        });
    }

    removeProfileImage(){
        const self = this;

        let param = {
            'user_photo': ''
        };

        loading(true);
        self.SSHttpService.putAPIRequest('sec/me', param).then(
            function (responseObj) {
                loading(false);

                if (responseObj instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(responseObj);
                        console.log(responseObj.data);
                        return;
                    }

                    self.updateLocalUser(responseObj.data.user);
                    self.SSAlertService.success('Success!', 'Profile image removed successfully!');
                    
            });
    }

    uploadProfilePhoto(files) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let file_name = file.name.replace(/ /g,"_");
        let format_type = null;

        if (file.type.indexOf("image") !== -1) {
            format_type = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }

        let policyUrl = 'sec/me/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self._uploadProfilePhoto(response.config.data.key, file_name, format_type);
        });
    }

    _uploadProfilePhoto(file_uri, file_name, format_type) {
        const self = this;

        let url= 'sec/me';
        //let url = '/sec/buyers/' + self.user.id + '/documents';
        let params = {
            file_uri: file_uri
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Profile image uploaded successfully.');
            self.user.photo = file_uri;
        });
    }

    // Upload/Remove/Replace 'Buyer' documents/images

    uploadDocumentFiles(files, file_name, upload_type, document_kind) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/buyers/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self._uploadDocument(response.config.data.key, file_name, upload_type, format_type, document_kind);
        });
    }

    _uploadDocument(file_uri, file_name, upload_type, format_type, document_kind) {
        const self = this;

        let url = 'sec/buyers/' + self.buyer.id + '/documents';
        let params = {
            name: file_name,
            type: upload_type,
            format: format_type,
            document_kind: document_kind,
            file_uri: file_uri
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (!self.buyer.hasOwnProperty("documents")) {
                self.buyer["documents"] = {};
            }
            self.buyer["documents"][file_name] = response.data.buyer_document;

            //To retrieve preview image
            url = 'sec/assets/presigned-url';
            params = {
                'model': self.ASSET_MODEL_BUYER_DOCUMENT,
                'id': response.data.buyer_document.id
            };
            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.buyer.documents[file_name]["show_file_url"] = response.data.presigned_url;
                self.SSAlertService.success('Success!', 'File uploaded successfully.');
            });

        });
    }

    removeDocument(documentObj, buyer) {
        const self = this;

        let url = 'sec/buyers/' + documentObj.buyer_id + '/documents/' + documentObj.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File deleted successfully.');

            buyer["documents"][documentObj.name] = null;
            self.updateProgressBarValue();
        });
    }

    replaceDocumentFiles(files, file_name, upload_type, document_kind, buyer, documentObj) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        //Delete existing file
        let url = 'sec/buyers/' + documentObj.buyer_id + '/documents/' + documentObj.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            buyer["documents"][documentObj.name] = null;
            self.uploadDocumentFiles(files, file_name, upload_type, document_kind, buyer);
        });
    }

    // End portion -> Upload/Remove/Replace 'Buyer' documents/images

    getPolicyDocument() {
        const self = this;

        return {
            then: function (callback) {
                if (self.policyDocData !== undefined) {
                    callback(true, self.policyDocData);
                } else {
                    self.SSHttpService.getAPIRequest('sec/me/s3-policy-document').then(function (responseObj) {
                        if (responseObj instanceof Error) {
                            callback(false, responseObj);
                            return;
                        }
                        callback(true, responseObj.data.policy);
                    });

                }
            }
        }
    }

    resetMainErrors() {
        const self = this;

        self.errUpdateFirstName = null;
        self.errUpdateLastName = null;
        self.errUpdateDisplayName = null;
        self.errUpdatePhone1 = null;
        self.errUpdateAddress = null;
        self.errUpdateCountry = null;
        self.errUpdatePostcode = null;
        self.errVerifyPhone1 = null;
        self.errVerifyPhone2 = null;
    }

    updateMain() {
        const self = this;
        
        self.resetMainErrors();
        
        if(!self.individual_occupation){
            self.err_individual_occupation = "The occupation field is required";
            $('html, body').animate({
                scrollTop: ($("#occupation").offset().top)
            }, 2000);
            self.SSAlertService.danger('Error!', 'Please fill-in valid information');
            return;
        }

        if (!self.validateModel(self, 'ctrl.', 'formPersonalDetails')) return;
        let param = {
            
            'buyerId': self.user.id,
            'email_contact_value': self.user.email,
            'phone1': self.phone1,
            'marital_status': self.individual_marital_status, // change it to user marital status
        };

        loading(true);
        self.SSHttpService.putAPIRequest('sec/me', param).then(
            function (responseObj) {
                self.updateMainLoadingIndicator = false;

                if (responseObj instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(responseObj);

                    let errorData = responseObj.data;

                    if (_.has(errorData, 'individual_legal_name')) {
                        self.errlegalName = errorData.individual_legal_name[0];
                    }
                    if (_.has(errorData, 'user_first_name')) {
                        self.errUpdateFirstName = errorData.user_first_name[0];
                    }
                    if (_.has(errorData, 'user_last_name')) {
                        self.errUpdateLastName = errorData.user_last_name[0];
                    }
                    if (_.has(errorData, 'user_display_name')) {
                        self.errUpdateDisplayName = errorData.user_display_name[0];
                    }
                    if (_.has(errorData, 'user_phone1')) {
                        self.errUpdatePhone1 = errorData.user_phone1[0];
                    }
                    if (_.has(errorData, 'user_address')) {
                        self.errUpdateAddress = errorData.user_address[0];
                    }
                    if (_.has(errorData, 'user_country')) {
                        self.errUpdateCountry = errorData.user_country[0];
                    }
                    if (_.has(errorData, 'user_postcode')) {
                        self.errUpdatePostcode = errorData.user_postcode[0];
                    }
                    // Additional params
                    if (_.has(errorData, 'user_marital_status')) {
                        self.errUpdateMaritalStatus = errorData.user_marital_status[0];
                    }
                    if (_.has(errorData, 'user_gender')) {
                        self.errUpdateGender = errorData.user_gender[0];
                    }
                    if (_.has(errorData, 'user_nationality')) {
                        self.errUpdateNationality = errorData.user_nationality[0];
                    }
                    if (_.has(errorData, 'user_national_id')) {
                        self.errUpdateNationalId = errorData.user_national_id[0];
                    }
                    if (_.has(errorData, 'user_passport_no')) {
                        self.errUpdatePassportNo = errorData.user_passport_no[0];
                    }
                    if (_.has(errorData, 'user_occupation')) {
                        self.errUpdateOccupation = errorData.user_occupation[0];
                    }
                    if (_.has(errorData, 'user_own_hdb')) {
                        self.errUpdateOwnHdb = errorData.user_own_hdb[0];
                    }
                    if (_.has(errorData, 'own_other_property')) {
                        self.errUpdateOwnOtherProperty = errorData.own_other_property[0];
                    }
                    if (_.has(errorData, 'no_of_own_properties')) {
                        self.errUpdateNoOfOwnProperties = errorData.no_of_own_properties[0];
                    }
                    return;
                }

                self.SSUtilService.log(responseObj);

                self.updateLocalUser(responseObj.data.user);

            });

        self.updateBuyer();
    }

    updateBuyer(){
        const self = this;

        let param = {
            'individual_legal_name': self.individual_legal_name? self.individual_legal_name.toUpperCase():self.individual_legal_name,
            'individual_first_name': self.updateFirstName? self.updateFirstName.toUpperCase():self.updateFirstName,
            'individual_last_name': self.updateLastName? self.updateLastName.toUpperCase():self.updateLastName,
            'individual_display_name': self.updateDisplayName,
            'phone1_contact_value': self.phone1_contact_value,
            'phone2_contact_value': self.phone2_contact_value,
            'individual_title': self.individual_title,

            'buyerId': self.buyer != null ? self.buyer.id : '',
            'email_contact_value': self.email_contact_value,

            //Additional Parameters
            'type': self.BUYER_TYPE_INDIVIDUAL, // 10 = Individual, 20 = Company
            'primary_address_line1': self.primary_address_line1,
            'primary_address_line2': self.primary_address_line2,
            'primary_address_unit_no': self.primary_address_unit_no,
            'primary_address_district': self.primary_address_district,
            'primary_address_city': self.primary_address_city,
            'primary_address_country': self.primary_address_country,
            'primary_address_postcode': self.primary_address_postcode,

            //Mailing Address Parameters
            'mailing_address_same': self.mailing_address_same,
            'mailing_address_line1': self.mailing_address_line1,
            'mailing_address_line2': self.mailing_address_line2,
            'mailing_address_unit_no': self.mailing_address_unit_no,
            'mailing_address_district': self.mailing_address_district,
            'mailing_address_city': self.mailing_address_city,
            'mailing_address_country': self.mailing_address_country,
            'mailing_address_postcode': self.mailing_address_postcode,

            'individual_dob': self.individual_dob,
            'individual_gender': self.individual_gender,
            'individual_identity_type': self.individual_identity_type,
            'individual_marital_status': self.individual_marital_status,

            'individual_nationality': self.individual_nationality,
            'individual_national_id': self.individual_national_id? self.individual_national_id.toUpperCase():self.individual_national_id,
            'individual_passport_no': self.individual_passport_no? self.individual_passport_no.toUpperCase():self.individual_passport_no,
            'individual_occupation': self.individual_occupation,
            'individual_industry': self.individual_industry,
            'user_own_hdb': self.updateOwnHdb,
            'user_own_other_property': self.updateOwnOtherProperty,
            'user_no_of_own_properties': self.updateNoOfOwnProperties
        };

        self.resetUpdateBuyerErrors();
        
        if(self.mailing_address_same){

            param.mailing_address_city = self.primary_address_city;
            param.mailing_address_country = self.primary_address_country;
            param.mailing_address_district = self.primary_address_district;
            param.mailing_address_line1 = self.primary_address_line1;
            param.mailing_address_line2 = self.primary_address_line2;
            param.mailing_address_postcode = self.primary_address_postcode;
            param.mailing_address_unit_no = self.primary_address_unit_no;

        }
        else{
            // Verify that required fileds are not empty

            let isValidMailingAddress = true;
            if(!self.mailing_address_line1){
                self.errUpdateMailingAddressLine1 = 'The mailing address line1 field is required.';
                isValidMailingAddress = false;
            }
            if(!self.mailing_address_country){
                self.errUpdateMailingAddressCountry = 'The mailing address country field is required.';
                isValidMailingAddress = false;
            }
            if(!self.mailing_address_postcode){
                self.errUpdateMailingAddressPostcode = 'The mailing address postcode field is required.';
                isValidMailingAddress = false;
            }

            if(!isValidMailingAddress){
                return;
            }
        }

        self.buyerApi(param).then(
            function (responseObj) {
                //self.updateMainLoadingIndicator = false;
                loading(false);

                if (responseObj instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(responseObj);

                    let errorData = responseObj.data;

                    if (_.has(errorData, 'individual_title')) {
                        self.errUpdateIndividualTitle = errorData.individual_title[0];
                    }
                    if (_.has(errorData, 'email_contact_value')) {
                        self.errUpdateEmailContact = errorData.email_contact_value[0];
                    }
                    if (_.has(errorData, 'individual_dob')) {
                        self.errUpdateIndividualDob = errorData.individual_dob[0];
                    }
                    if (_.has(errorData, 'individual_first_name')) {
                        self.errUpdateIndividualFirstName = errorData.individual_first_name[0];
                    }
                    if (_.has(errorData, 'individual_last_name')) {
                        self.errUpdateIndividualLastName = errorData.individual_last_name[0];
                    }
                    if (_.has(errorData, 'individual_gender')) {
                        self.errUpdateIndividualGender = errorData.individual_gender[0];
                    }
                    if (_.has(errorData, 'individual_identity_type')) {
                        self.errUpdateIndividualIdentityType = errorData.individual_identity_type[0];
                    }
                    if (_.has(errorData, 'individual_national_id')) {
                        self.errUpdateIndividualNationalId = errorData.individual_national_id[0];
                    }
                    if (_.has(errorData, 'individual_nationality')) {
                        self.errUpdateIndividualNationality = errorData.individual_nationality[0];
                    }
                    if (_.has(errorData, 'phone1_contact_value')) {
                        self.errUpdateBuyerPhone1 = errorData.phone1_contact_value[0];
                    }
                    if (_.has(errorData, 'primary_address_country')) {
                        self.errUpdatePrimaryAddressCountry = errorData.primary_address_country[0];
                    }
                    if (_.has(errorData, 'primary_address_line1')) {
                        self.errUpdatePrimaryAddressLine1 = errorData.primary_address_line1[0];
                    }
                    if (_.has(errorData, 'primary_address_postcode')) {
                        self.errUpdatePrimaryAddressPostcode = errorData.primary_address_postcode[0];
                    }
                    return;
                }

                self.SSUtilService.log('After create/update buyer');
                self.SSUtilService.log(responseObj);

                self.SSAlertService.success('Success!', 'Profile information updated successfully!');
                self.getBuyerProfile(); // Get and update local buyer

                //self.setUpdateMainContainer(false);
            });
    }

    buyerApi(param) {
        const self = this;

        // Buyer Update API url: /sec/buyers/{buyerId} 
        // Buyer Post API url: /sec/buyers
         
        let url = 'sec/buyers/';

        if(self.buyer && self.buyer.id){
            url += self.buyer.id;
        }

        return {
            then: function (callback) {
                if (!self.buyer) {
                    
                    self.SSHttpService.postAPIRequest(url, param).then(function (responseObj) {
                        callback(responseObj);
                    });
                } else {
                    
                    self.SSHttpService.putAPIRequest(url, param).then(function (responseObj) {
                        callback(responseObj);
                    });
                }
            }
        }
    }

    resetUpdateBuyerErrors() {
        const self = this;

        self.errUpdateEmailContact = null;
        self.errUpdateIndividualDob = null;
        self.errlegalName = null;
        self.errUpdateIndividualFirstName = null;
        self.errUpdateIndividualLastName = null;
        self.err_individual_occupation = null;
        self.errUpdateIndividualGender = null;
        self.errUpdateIndividualIdentityType = null;
        self.errUpdateIndividualNationalId = null;
        self.errUpdateIndividualNationality = null;
        self.errUpdateBuyerPhone1 = null;
        self.errUpdatePrimaryAddressCountry = null;
        self.errUpdatePrimaryAddressLine1 = null;
        self.errUpdatePrimaryAddressPostcode = null;
        self.errUpdateMailingAddressLine1 = null;
        self.errUpdateMailingAddressCountry = null;
        self.errUpdateMailingAddressPostcode = null;
    }

    makeid() {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (let i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('input[type=tel]'), function(i, el) {
        
        let field = jQuery(el);
        
        //let field =  jQuery('#f3');
        let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');

            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                 
                let value = self.$parse(model)(context);

                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {
                field.parent().removeClass("has-warning");
            });
            field.blur(function () {
                
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-warning");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-warning");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }

                self.$timeout(function() {
                    self.updateProgressBarValue();
                });
                
            });
        });

    }

    validateModel(context, contextPrefix, formId) {
        let self = this;

        let parent = null;

        if (formId) {
            parent = jQuery('#'+formId);
            //console.log(formId);
        } else {
            parent = jQuery('body');
        }

        let valid = true;
        if(jQuery("#f3").val() !==""){
            //console.log('here in add');
            jQuery("#f3").attr("required","required");
        }
        if(jQuery("#f3").val() ==""){
            //console.log('here in remove');
            jQuery("#f3").removeAttr("required");
        }
        //_.forEach(["#f0","#f1","#f2","#f3","#f4","#f5","#f6","#f7"], function(fl) {
        _.forEach(["#f0","#f1","#f2","#f3"], function(fl) {
            let field = jQuery(fl);
            //console.log("check valid");
            //console.log(field);
            // Clear the error
            field.parent().removeClass("has-warning");

            // Return if not required field
            let required = field.attr('required');
            if (!required || required === 'false') {
                return;
            }
            // Verify field has ng-model or ng-model specified
            let attr = 'ng-model';

            if (field.attr('type') === 'tel') {
                attr = 'ng-model';
            } else if (field.attr('type') === 'jdate') {
                attr = 'jdate-ng-model';
            }
            if(field.attr('id')=='f3'){
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-warning");
                    //valid = false; // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                }
            }
            let model = self._getModelName(field, attr, contextPrefix);
          //  console.log("MODEL");
           // console.log(model);
            if (!model) return;

            // Now validate the non-empty value
            let value = self.$parse(model)(context);

            if (jQuery.isNumeric(value)) {
                let allowzero = field.attr('allow-zero');
                allowzero = allowzero !== undefined && allowzero !== 'false';

                if(!((allowzero && value === 0) || value)){
                    valid = false;
                }

            } else if (!value) {
                valid = false;
            }

            if (!valid) {
                field.parent().addClass("has-warning");
                //console.log("adding error");
                //console.log(field.parent());
                field.focus();
                return false;
            }
        });
        return valid;
    }

    _getModelName(field, attr, prefix) {
        let model = field.attr(attr);
        if (!model) return;
        if (prefix) {
            if (!startsWith(model, prefix)) return;
            model = model.substring(prefix.length);
        }
        return model;
    }

    verifyMobileNumber(id){
        const self = this;

        let contactNumber = self.getContactNumber(id);
        self.errVerifyPhone1 = "";
        self.class_phone1 = "text-danger";

        if(!contactNumber){
            self.errVerifyPhone1 = "Please enter a valid phone number";
        }
        else if(!self.buyer? contactNumber:self.buyer.phone1_contact? (self.buyer.phone1_contact.value != contactNumber && !self.phone1_contact_value_verified):(contactNumber && !self.phone1_contact_value_verified)){
            self.errVerifyPhone1 = "Please save changes and then verify the phone number";
        }
        else if(self.buyer.phone1_contact? (contactNumber == self.buyer.phone1_contact.value && self.phone1_contact_value_verified):false){
            self.errVerifyPhone1 = "Phone number is already verified";
            self.class_phone1 = "";
        }
        else if(!self.phone1_contact_value_verified){
            self.verificationModal(id);
        }
    }

    verifyContactNumber(id){
        const self = this;

        let contactNumber = self.getContactNumber(id);
        self.errVerifyPhone2 = "";
        self.class_phone2 = "text-danger";

        if(!contactNumber){
            self.errVerifyPhone2 = "Please enter a valid phone number";
        }
        else if(!self.buyer? contactNumber:self.buyer.phone2_contact? (self.buyer.phone2_contact.value != contactNumber && !self.phone2_contact_value_verified):(contactNumber && !self.phone2_contact_value_verified)){
            self.errVerifyPhone2 = "Please save changes and then verify the phone number";
        }
        else if(self.buyer.phone2_contact? (contactNumber == self.buyer.phone2_contact.value && self.phone2_contact_value_verified):false){
            self.errVerifyPhone2 = "Phone number is already verified";
            self.class_phone2 = "";
        }
        else if(!self.phone2_contact_value_verified){
            self.verificationModal(id);
        }
    }

    getContactNumber(id){
        const self = this;

        let field = $('#' + id);
        let model = field.attr('ng-model');

        let contactNumber = $('#' + id).val();

        if(field){
            var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
            field.val(field.intlTelInput("getNumber", currentFormat));

            contactNumber = field.intlTelInput("getNumber");

            field.parent().removeClass("has-warning");
            if (!field.intlTelInput("isValidNumber")) {
                field.parent().addClass("has-warning");

                //return ''; // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
            }
        }
        
        return contactNumber;   
    }

    verificationModal(id){
        const self = this;

        let field = $('#' + id);
        let model = field.attr('ng-model');
        self.verify_code_error = '';

        if(field){
            var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
            field.val(field.intlTelInput("getNumber", currentFormat));

            let contactNumber = field.intlTelInput("getNumber");

            field.parent().removeClass("has-warning");
            if (!field.intlTelInput("isValidNumber")) {
                field.parent().addClass("has-warning");
                //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
            } else {

                let url = 'sec/buyers/'+ self.buyer.id +'/request-contact-verification';
                let param ={
                    'field': id,
                }

                // Call API to send a code
                loading(true);
                self.SSHttpService.postAPIRequest(url, param).then(function (responseObj) {
                    loading(false);
                    if (responseObj instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(responseObj);
                        return;
                    }
                    if(response && response.data && response.data.prefix_2fa){
                        self.prefix_2fa = response.data.prefix_2fa;
                    }
                    // Display modal to get verification code input
                    self.modal = true;
                    $('#contactVerificationModal').modal(self.modal);
                });
            }
        }

    }

    verifyCode(){
        const self = this;
        
        self.verify_code_error = '';

        if(!self.verify_code_input || self.verify_code_input.length < 6){
            self.verify_code_error = 'Please enter a 6 digit verification code';
            return;
        }

        let url = 'verify/' + self.verify_code_input;
        // Call 'GET verify/{token}' api
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (responseObj) {
            loading(false);
            if (responseObj instanceof Error) {
                self.verify_code_error = responseObj.message;
                return;
            }
            console.log(responseObj);
            angular.element('#contactVerificationModal').modal('hide');
            self.SSAlertService.success('Success!', 'Phone number verified successfully');
            self.$window.location.reload();
        });
    }

    hideModals() {
        const self = this;

        self.showModal = false;

        if ($('#updateTwoFAModal').is(':visible')) $('#updateTwoFAModal').modal('hide');
    }

}

CustomerFolioController.$inject = ['$parse', '$window', '$timeout', 'Upload', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSUserService', 'SSAppService', 'SSEoiService', 'SSAwsService', 'SSAlertService', 'SSConfirmationService'];
app.controller('CustomerFolioController', CustomerFolioController);
